import React from 'react';
import { aboutVshesh } from '../data/mock';

const AboutSection = () => {
  return (
    <section 
      id="about" 
      className="py-12 bg-gradient-to-b from-white via-green-50/20 to-white"
      aria-labelledby="about-heading"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 
            id="about-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
          >
            About <span className="text-green-800">v-shesh</span>
          </h2>
          
          <p className="text-xl text-green-800 font-semibold mb-6">
            {aboutVshesh.tagline}
          </p>
          
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            {aboutVshesh.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
